import { matchValues } from '@shared/core/types/common';

const unitTypes: OLO.Types.UNIT_TYPES[] = ['metric', 'imperial'];

export const unitTypesType = matchValues(...unitTypes);
